<template>
    <ion-card button="true" @click="addAlert">
        <ion-list>
            <ion-item lines="none">
                <ion-icon name="add-circle"></ion-icon>
            </ion-item>
            <ion-item lines="none" text-center>
                <ion-label>{{ $t('components.no-alerts.add-alert') }}</ion-label>
            </ion-item>
        </ion-list>
    </ion-card>
</template>

<script>
    export default {
        name: 'NoAlerts',
        methods: {
            addAlert: function() {
                this.$router.push('/add-alert');
            }
        }
    }
</script>

<style scoped>
    ion-list {
        background: none;
    }

    ion-item {
        --background: none;
    }

    ion-icon {
        font-size: 5em;
        color: #999;
        margin: 0 auto;
    }

    ion-icon:hover {
        color: #f05;
    }

    ion-label {
        font-family: 'Nunito', sans-serif !important;
        font-weight: bold;
        color: #666 !important;
    }
</style>